import React, { FC } from 'react'
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch'

import {
  AssetWithDocumentProps,
  ZoomControllers,
  ZoomControllerTheme,
} from '@avantstay/backoffice-core'

import * as S from '../ImagePreviewModal/ImagePreviewModal.styles'

interface ImagePreviewZoomProps {
  asset: AssetWithDocumentProps
}

export const ImagePreviewZoom: FC<ImagePreviewZoomProps> = ({ asset }) => {
  return (
    <TransformWrapper initialScale={1}>
      {({ zoomIn, zoomOut }) => (
        <S.ImageZoomWrapper>
          <S.ZoomWrapper>
            <ZoomControllers
              theme={ZoomControllerTheme.primaryVertical}
              onClickZoomIn={() => zoomIn()}
              onClickZoomOut={() => zoomOut()}
            />
          </S.ZoomWrapper>
          <TransformComponent>
            <S.ImageWrapper>
              <S.ImagePreview src={asset.url} fit="contain" />
            </S.ImageWrapper>
          </TransformComponent>
        </S.ImageZoomWrapper>
      )}
    </TransformWrapper>
  )
}
